import { bucket_url } from '../constants/const'

export const listPhotos = lists => {
  let allItems = []
  allItems = [...lists.map(item => item.pictures)]
  allItems = allItems.flat()
  const items = allItems.map(item => ({ title: item.caption, src: `${bucket_url}${item.image}`, width: item.width, height: item.height, featuredAt: item.featuredAt }))
  return items
}

export const makePhotoObject = photos => {
  return photos.map(item => ({ title: item.caption, src: `${bucket_url}${item.image}`, width: item.width, height: item.height }))
}

export const listVideos = lists => {
  let allVideos = []
  allVideos = [...lists.map(item => item.videos)]
  allVideos = allVideos.flat()
  return allVideos
}